

























































import { PaymentList } from '@/models/api/payment/payment'
import { PluginMixin } from '@spa/mixins/plugin'
import { isCreditCard, Payment } from '@spa/store/modules/orderConfirm/types'
import { fromNullable } from 'fp-ts/lib/Option'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ViewItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  /**
   * FIXME:
   * 2022/05/24時点の実装上、paymentから必ずしもラベル情報などが取得できない.
   * 事前の処理ルートによって取得できたりできなかったりの実装になっているのを一元化して、
   * 型定義上もラベル等の情報を確実に取得できることを保証する.
   *
   * @see client/spa/src/store/modules/orderConfirm/actions.ts setXxxxから個別に設定・上書きされると情報が消える
   */
  readonly payment: Payment

  @Prop({ required: true })
  /**
   * paymentから必ずしもラベル情報などを取得できないので、止む無く別途参照.
   * payment経由で詳細を取得できることが保証されたら、このフィールドそのものが不要.
   */
  readonly availablePaymentList: PaymentList

  @Prop({ required: true })
  readonly pathToEdit: string

  get paymentType() {
    return this.payment.payment_type
  }
  get creditCardSelected() {
    return isCreditCard(this.payment)
  }

  /**
   * FIXME: 「支払い方法」の名称が複数箇所で個別に定義され、散在している
   *
   * サーバー側のデータ定義に表示も全て統合させ、clientでは個別に考慮しなくて良いようにするべき
   *
   * @see getPaymentLabel
   * @see src/Model/Payment/Kind
   */
  get paymentLabel(): string {

    return fromNullable(this.availablePaymentList.find(p => p.id === this.paymentType)).foldL(
      () => { throw new Error(`${this.paymentType} is unexpected payment method`) },
      (p) => {
        /**
         * https://github.com/my-color/front/issues/6415 のワークアラウンド。
         * TODO: APIレスポンスの値と、ユーザの選択状態（Vuex）に基づく値の組み合わせでラベルを生成しているが、少なくともどちら片方に寄せたほうがよい。
         *
         * 基本的にはサーバ側のデータに寄せるべきであるが、ユーザの選択状態の生成自体がサーバ側のデータに準拠して行われているならば、
         * 意味的にはむしろここではユーザが希望する選択状態のラベル表現をするのが責務と考えることもできる。
         * 利用を希望するユーザの選択状態と利用可能な支払い方法の差異は、まさに利用可能であるかどうかのバリデーションに帰着するが、
         * ここではそのバリデーションが行われている前提なので、むしろユーザの選択状態からラベルを生成してもよいように思われる。
         */
        return this.payment.selectedOptionList && this.payment.selectedOptionList.first ?
          /**
           * optionのうち、当面は一つのみ（コンビニ・キャリア決済の下位分類）を表示すればよい。
           * この前提が変われば、どんなoptionをどの順序でどんなフォーマットで結合して表示すべきか、仕様を明確に定義して調整すること。
           */
          `${p.label} - ${this.payment.selectedOptionList.first.label}` :
          p.label
      }
    )
  }
}
